import { Link } from 'react-router-dom';
import { LOGOS } from '../cdn';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 sm:mt-32 border-t border-[color:var(--color-line)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-5 py-10 sm:py-14 grid gap-8 grid-cols-2 sm:grid-cols-4">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-xl overflow-hidden ring-1 ring-[color:var(--color-brand)]/25 bg-[color:var(--color-bg)]">
              <img src={LOGOS.vpnee} alt="" width={36} height={36} className="w-full h-full object-cover" />
            </span>
            <span className="font-[family-name:var(--font-display)] text-xl font-extrabold">Vpnee</span>
          </Link>
          <p className="mt-3 text-sm text-[color:var(--color-ink-dim)] max-w-sm leading-relaxed">
            Zero-log Xray REALITY tunnel with post-quantum VLESS encryption. Built by TNIDU Inc. for people who want the internet on their own terms.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[color:var(--color-ink-faint)] mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/features">Features</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/pricing">Pricing</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/download">Download</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/docs">Docs</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/help">Help</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/changelog">Changelog</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[color:var(--color-ink-faint)] mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/about">About</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/privacy">Privacy</Link></li>
            <li><Link className="text-[color:var(--color-ink-dim)] hover:text-white" to="/terms">Terms</Link></li>
            <li><a className="text-[color:var(--color-ink-dim)] hover:text-white" href="mailto:hello@tnidu.com">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--color-line)]">
        <div className="max-w-6xl mx-auto px-4 sm:px-5 py-5 flex flex-wrap gap-3 justify-between text-xs text-[color:var(--color-ink-faint)]">
          <span>© {year} Vpnee — All rights reserved. · Build By <a href="https://tnidu.com" target="_blank" rel="noreferrer" className="text-[color:var(--color-brand-glow)] hover:underline">TNIDU Inc.</a></span>
          <span>Powered by Xray REALITY + post-quantum VLESS · Built with React + Vite</span>
        </div>
      </div>
    </footer>
  );
}
